<!--
 * @description: 代码生成器自动生成
 * @author: liyubao | xufuxing
 * @version: 1.0
-->
<template>
  <div class="flex-column">

    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-button type="text" class="filter-item" style="color:#333" size="mini">选择关联表单：</el-button>
        <el-select v-model="selectedForm" @change="handleFormSelectionChange" filterable remote reserve-keyword
          placeholder="请输入表单关键词" :remote-method="remoteMethod" size="mini" style="width:20vw;margin-right:20px"
          :loading="loading">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>


        <el-input @keyup.enter.native="handleFilter" size="mini" style="width: 200px;" class="filter-item"
          :placeholder="'名称'" v-model="listQuery.key"> </el-input>
        <el-button class="filter-item" size="mini" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <el-button type="warning" class="warning filter-item" size="mini" @click="godesign">去设计</el-button>

        <permission-btn size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table style="height:calc(100% - 60px)" ref="mainTable" :select-type="'checkbox'"
          :table-fields="headerList" :data="list" :v-loading="listLoading" @row-click="rowClick"
          @selection-change="handleSelectionChange"></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          @pagination="handleCurrentChange" />
      </div>


      <el-dialog v-el-drag-dialog class="dialog-mini" width="500px" :title="textMap[dialogStatus]"
        :visible.sync="dialogFormVisible">
        <auth-form ref="dataForm" :rules="rules" :edit-model="true" :form-fields="headerList" v-model="temp"
          :col-num="2"></auth-form>
        <div slot="footer">
          <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="mini" v-if="dialogStatus == 'create'" type="primary" @click="createData">确认</el-button>
          <el-button size="mini" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- <sysrptsmin style="height: 100%;"></sysrptsmin> -->




  </div>
</template>
<script>
  import * as sysRpts from '@/views/dlsvprint/api/sysRpts'
  import waves from '@/directive/waves' // 水波纹指令
  import Sticky from '@/components/Sticky'
  import sysrptsmin from '../index.vue'
  import permissionBtn from '@/components/PermissionBtn'
  import Pagination from '@/components/Pagination'
  import elDragDialog from '@/directive/el-dragDialog'
  import { defaultVal } from '@/utils/index'
  import extend from '@/extensions/delRows.js'
  import AuthForm from '@/components/Base/AuthForm.vue'
  import AuthTable from '@/components/Base/AuthTable.vue'
  import ColumnDefine from '@/interface/columnDefine'
  import * as forms from '@/api/forms'
  import EventBus from "@/utils/EventBus";
  export default {
    name: 'sysRpt',
    components: { Sticky, permissionBtn, Pagination, AuthTable, AuthForm, sysrptsmin },
    directives: {
      waves,
      elDragDialog,
    },
    inject: ['reload'],
    mixins: [extend],
    data() {
      return {
        headerList: [], // 主列表列定义
        multipleSelection: [], // 列表checkbox选中的值
        tableKey: 0,
        list: null,
        total: 0,
        sysrptsminshow: false,
        formlist: [],
        options: [],
        loading: false,
        selectedForm: {},
        listLoading: true,
        listQuery: {
          // 查询条件
          page: 1,
          limit: 20,
          key: undefined,
          formId: ''
        },
        formQuery: {
          //表单查询条件
          page: 1,
          limit: 20,
          key: undefined,
        },
        temp: {},
        dialogFormVisible: false,
        dialogStatus: '',
        textMap: {
          update: '编辑',
          create: '添加',
        },
        rules: {
          name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        },
      }
    },
    created() {
      this.headerList = [
        new ColumnDefine('id', '打印方案ID', true, true, '', '', 'string', 'char', 'id'),
        new ColumnDefine('orgid', '机构ID', true, true, '', '', 'string', 'char', 'orgid'),
        new ColumnDefine('rftype', '相关类型', true, false, '', '', 'string', 'char', 'rftype'),
        new ColumnDefine('langid', '语言标识', true, false, '', '', 'string', 'varchar', 'langid'),
        new ColumnDefine('formid', '表单ID', true, true, '', '', 'string', 'char', 'formid'),
        new ColumnDefine('rptname', '名称', true, true, '', '', 'string', 'nvarchar', 'rptname'),
        new ColumnDefine('categories', '分类', true, false, '', '', 'string', 'varchar', 'categories'),
        new ColumnDefine('entity', '实体', true, false, '', '', 'string', 'text', 'entity'),
        new ColumnDefine('lastmodifytime', '最后更新时间', true, true, '', '', 'string', 'varchar', 'lastmodifytime'),
        // new ColumnDefine('ver', '版本号', true, true, '', '', 'string', 'varchar', 'ver'),
        new ColumnDefine('description', '描述', true, true, '', '', 'string', 'text', 'description'),
        // new ColumnDefine('rfid', '相关ID', true, true, '', '', 'string', 'char', 'rfid'),

      ]
      this.getList()
    },
    mounted() {

      // EventBus.$on("loading", (row) => {
      //   console.log(7489);
      //   this.po()
      // });
    },
    methods: {
      po() {
        this.reload()
      },
      rowClick(row) {
        // console.log(row);
        this.prinid = row.id
        this.$refs.mainTable.clearSelection()
        this.$refs.mainTable.toggleRowSelection(row)
      },
      handleSelectionChange(val) {
        // console.log(val);
        this.prinid = val[0].id
        this.multipleSelection = val
      },
      godesign() {
        if (this.multipleSelection.length == 0 || this.multipleSelection.length > 1) {
          this.$message({
            message: '只能选中一个进行编辑',
            type: 'error',
          })
          return
        } else {
          let routerData = this.$router.resolve({ path: '/printData', query: { row: JSON.stringify(this.multipleSelection[0]) } })
          window.open(routerData.href, '_blank')
        }

      },



      onBtnClicked: function (domId, callback) {
        console.log('you click:' + domId)
        switch (domId) {
          case 'btnAdd':
            this.handleCreate()
            break
          case 'btnEdit':
            if (this.multipleSelection.length !== 1) {
              this.$message({
                message: '只能选中一个进行编辑',
                type: 'error',
              })
              return
            }
            this.handleUpdate(this.multipleSelection[0])
            break
          case 'btnDel':
            if (this.multipleSelection.length < 1) {
              this.$message({
                message: '至少删除一个',
                type: 'error',
              })
              return
            }
            this.handleDelete(this.multipleSelection)
            break
          case 'btnExport':
            this.$refs.mainTable.exportExcel('资源文件', callback)
            break
          default:
            break
        }
      },
      getList() {
        this.listLoading = true
        sysRpts.getList(this.listQuery).then((response) => {

          console.log(response);

          this.list = response.data
          this.total = response.count
          this.listLoading = false
        })
        // forms.getList(this.listQuery).then((response) => {
        //   this.list = response.data
        //   this.total = response.count
        //   //this.page = response.page
        //   this.updateIsRender(false)
        //   this.listLoading = false
        // })
      },

      handleFilter() {
        this.listQuery.page = 1
        this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.limit = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.listQuery.page = val.page
        this.listQuery.limit = val.limit
        this.getList()
      },
      handleModifyStatus(row, disable) {
        // 模拟修改状态
        this.$message({
          message: '操作成功',
          type: 'success',
        })
        row.disable = disable
      },
      resetTemp() {
        let obj = {};
        this.headerList.forEach((item) => {
          obj[item.columnName] = defaultVal(item.entityType)
        })
        this.temp = Object.assign({}, obj) // copy obj
      },
      handleCreate() {
        // 弹出添加框
        this.resetTemp()
        this.dialogStatus = 'create'
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      createData() {
        // 保存提交
        this.$refs['dataForm'].validate(() => {
          sysRpts.add(this.temp).then(() => {
            this.list.unshift(this.temp)
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000,
            })
          })
        })
      },
      handleUpdate(row) {
        // 弹出编辑框
        this.temp = Object.assign({}, row) // copy obj
        this.dialogStatus = 'update'
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      updateData() {
        // 更新提交
        this.$refs['dataForm'].validate(() => {
          const tempData = Object.assign({}, this.temp)
          // console.log(this.temp);
          sysRpts.update(this.temp).then(() => {
            for (const v of this.list) {
              if (v.id === this.temp.id) {
                const index = this.list.indexOf(v)
                this.list.splice(index, 1, this.temp)
                break
              }
            }
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000,
            })
          })
        })
      },
      handleDelete(rows) {
        // 多行删除
        this.delrows(sysRpts, rows)
      },

      remoteMethod(query) {
        console.log(query)
        if (query !== '') {
          this.loading = true;
          this.formQuery.key = query;
          forms.getList(this.formQuery).then((response) => {

            this.options = response.data
            this.total = response.count
            //this.page = response.page
            //this.updateIsRender(false)
            this.loading = false
          })
          //   setTimeout(() => {
          //     this.loading = false;
          //     this.options = this.list.filter(item => {
          //       return item.label.toLowerCase()
          //         .indexOf(query.toLowerCase()) > -1;
          //     });
          //   }, 200);
        } else {
          this.options = [];
        }
      },
      handleFormSelectionChange(val) {
        // console.log(val)
        this.listQuery.formId = val;
        this.getList()
      }
    },
  }
</script>
<style>
  .dialog-mini .el-select {
    width: 100%;
  }
</style>